module.exports = __webpack_public_path__ + "img/img_left_nav_sale_hover.531572e5.svg";